
export class HttpClientConfiguration {
    telemetry: boolean = false;
    telemetryStoreDelay: number = 6000;
    timeout: number = 60000;
}